import APIClinicAgency from '@/api/modules/clinicAgency';

const initialState = {
  // currently linked agency id for the opened clinic (first link), null if none
  clinicAgencyId: null,
  // all agency ids linked to the clinic (agencies_clinics is many-to-many)
  clinicAgencyIds: [],
  // details of the primary linked agency: { id, name_en, country_code, hide }
  clinicAgency: null,
};

export default {
  namespaced: true,
  state: initialState,
  mutations: {
    SET_DATA(state, { type, data }) {
      state[type] = data;
    },
  },
  actions: {
    getClinicAgency({ commit }, clinicId) {
      return APIClinicAgency.getClinicAgency(clinicId).then((response) => {
        if (response && response.data) {
          commit('SET_DATA', { type: 'clinicAgencyId', data: response.data.agency_id ?? null });
          commit('SET_DATA', { type: 'clinicAgencyIds', data: response.data.agency_ids || [] });
          commit('SET_DATA', { type: 'clinicAgency', data: response.data.agency || null });
        }
      });
    },
    /**
     * Replace the single agency shown on the clinic card.
     * Unlinks the previously shown agency (if any) and links the new one,
     * preserving any other links the clinic may have.
     */
    async saveClinicAgency(_, { clinicId, agencyId, previousAgencyId }) {
      if (previousAgencyId && previousAgencyId !== agencyId) {
        await APIClinicAgency.unlinkClinicAgency({ agencyId: previousAgencyId, clinicId });
      }
      if (agencyId) {
        await APIClinicAgency.linkClinicAgency({ agencyId, clinicId });
      }
    },
  },
};
